import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../http/query-client';
import {BackendResponse} from '../../http/backend-response/backend-response';

export interface EmailAvailabilityResponse extends BackendResponse {
  email: string;
  valid: boolean;
  available: boolean;
  reason: 'empty' | 'invalid_format' | 'blocked_domain' | 'taken' | null;
  message?: string;
}

export function useEmailAvailability(email: string, enabled: boolean) {
  return useQuery({
    queryKey: ['auth', 'email-availability', email],
    queryFn: () => checkEmailAvailability(email),
    enabled,
    retry: false,
    staleTime: 15000,
  });
}

function checkEmailAvailability(
  email: string,
): Promise<EmailAvailabilityResponse> {
  return apiClient
    .get<EmailAvailabilityResponse>('auth/email/check', {
      params: {email},
    })
    .then(response => response.data);
}
